const repairLogProfile = {
  title: "PERFIL DE REPARACIONES",
  tag: "TAG del Activo",
  type: "Tipo de Activo",
  date: "Fecha de Creación",
  createdby: "Creado Por",
  log: "Registro",
  deletebtn: "ELIMINAR REPARACIÓN",
  backbtn: "Atrás"
};

export default repairLogProfile;
